import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsWorkOrderStatus, PmsWorkOrderStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsWorkOrderStatus>
    useData={usePmsWorkOrderStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
